import React from 'react'

import AdminNavbar from '../components/Navbar/AdminNavbar'
import AdminCourse from '../components/Admin/AdminCourse'
import AdminPost from '../components/Admin/AdminPost'
import ContactList from '../components/Contact/ContactList'

const AdminCommentPage = () => {
  return (
    <>
    <AdminNavbar/>
    <ContactList/>
    </>
  )
}

export default AdminCommentPage